var responsive = {
	xxs: 375,
	xs: 425,
	sm: 750,
	md: 1025,
	lg: 1200,
	xlg: 1440,
}

const isMinBreakpoint = breakpoint => {
	if ( responsive[ breakpoint ] == undefined ) return false
	return window.innerWidth >= responsive[ breakpoint ]
}

const isMaxBreakpoint = breakpoint => {
	if ( responsive[ breakpoint ] == undefined ) return false
	return window.innerWidth < responsive[ breakpoint ]
}

export {responsive, isMinBreakpoint, isMaxBreakpoint}
